var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "RiskCheckParam",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "reCaptchaToken",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "payload",
                    "id": 2
                }
            ]
        },
        {
            "name": "Mall",
            "fields": [],
            "messages": [
                {
                    "name": "PayOrder",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "MallPayOrder",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "purpose",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "productId",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "channel",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "tradeType",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "tuid",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "returnUrl",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "clientType",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "platform",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "rewardType",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "rewardConfigId",
                                    "id": 10
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "ext",
                                    "id": 11
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "pageId",
                                    "id": 12
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "cuid",
                                    "id": 13
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "blackbox",
                                    "id": 14
                                },
                                {
                                    "rule": "optional",
                                    "type": "RiskCheckParam",
                                    "name": "riskCheckParam",
                                    "id": 15
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "OrderInfo",
                                    "name": "orderInfo",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "wconfig",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "pconfig",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "aconfig",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "bconfig",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "h5",
                                    "id": 6
                                }
                            ]
                        },
                        {
                            "name": "OrderInfo",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "orderId",
                                    "id": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/order/orderpb.js